import { FeatureFlag } from '../FeatureFlag';

export const useAlphaEyeVolumeProfileTab = new FeatureFlag({
    key: 'use-alpha-eye-volume-profile-tab',
    createdOn: '2026-06-23',
    defaultValue: false,
});
